var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAqi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.046,
    height: 23.024,
    viewBox: "0 0 107.046 23.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#c22125}.cls-3{font-family:CenturyGothicPro,Century Gothic Pro;font-weight:400}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_AQI",
    transform: "translate(0 -.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M212.919 148.9a3.247 3.247 0 0 0-3.233 3.308 3.21 3.21 0 0 0 3.222 3.244 3.266 3.266 0 0 0 1.665-.437l-1.719-2.177h.939l1.366 1.74a3.305 3.305 0 0 0-2.241-5.677z",
    className: "cls-1",
    transform: "translate(-202.285 -142.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M38.92 167.938h2.229l-1.114-2.768z",
    className: "cls-1",
    transform: "translate(-37.119 -157.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M77.784 21.5c-8.322 3.236-10.634 0-10.634 0v7.26l1.288-3.2h1.619l3.251 8.081h-1.665l-.657-1.666h-3.44l-.394.946v3.989s4.469 3.159 10.711 0c0 0 7.705-3.313 11.943-.077V21.5s-3.699-3.237-12.022 0zm3.044 12.237h-.939l-.778-.992a3.915 3.915 0 0 1-2.123.576 4.022 4.022 0 1 1 4.033-4.02 3.89 3.89 0 0 1-1.323 3z",
    className: "cls-1",
    transform: "translate(-66.343 -20.06)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "AsiaQuest",
    fontFamily: "CenturyGothicPro-Bold, Century Gothic Pro",
    fontSize: "4px",
    fontWeight: 700,
    transform: "translate(0 22.025)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Asia"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-3"
  }, "Quest")), /*#__PURE__*/React.createElement("text", {
    id: "AsiaQuest_Indonesia",
    fontFamily: "CenturyGothicPro-Bold, Century Gothic Pro",
    fontSize: "8px",
    fontWeight: 700,
    transform: "translate(27.046 12.268)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AsiaQuest "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    className: "cls-3"
  }, "Indonesia")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAqi);
export default __webpack_public_path__ + "static/media/logo_aqi.7aa34b52283b6a7afcdf5bccce152932.svg";
export { ForwardRef as ReactComponent };